import { AbstractIdbaModel } from "src/app/shared/models/abstract-idba-model";

export class Produto extends AbstractIdbaModel {

    override convertToModel(data: any): Produto {
        return new Produto(data);
    }

    override display(self: any): string {
        if (self.displayWith) {
            return self.displayWith;
        } else {
            self.displayWith = self && self.produtoCod ? `${self.produtoCod} - ${self.nomeProduto}` : '';
            return self.displayWith;
        }
    }

    override displayCodigo(self: any): string {
        return self && self.codigoProduto ? `${self.codigoProduto}` : '';
    }

    override displayNome(self: any): string {
        return self && self.nomeProduto ? `${self.nomeProduto}` : '';
    }

    override filter(value: string, objectList: Produto[]): Produto[] {
        const filterValue = value.toLowerCase();
        return objectList.filter((item) =>
            (item.produtoCod).toString().trim().toLowerCase().includes(filterValue) ||
            item.nomeProduto.toString().toLowerCase().includes(filterValue)
        );
    }

    codigoProduto: number; // Produto.prd_id
    produtoCod: string; // Produto.prd_codigo
    nomeProduto: string;
    codigoTipoItem: number;
    codigoGrupoItem: number;
    codigoMarcaItem: number;
    codigoFamilia: number;
    nomeFamilia: string;
    gtin: string;
    codigoOrigem: number;
    codigoFornecedor: number;
    nomeFornecedor: string;
    codigoEspTransp: number | null;
    codigoUnVendaItem: number;
    pesoEmbVenda: number;
    pesoUnVenda: number;
    codigoUnCompraItem: number;
    pesoEmbCompra: number;
    pesoUnCompra: number;
    codigoUnArmazenagemItem: number;
    pesoEmbArmaz: number;
    pesoUnArmaz: number;
    codigoTipoControleEstoque: number;
    codigoDeposito: number;
    controlaEtiqueta: boolean;
    idTipoTarefa: number;
    idDivisao: number;
    idServ: number;
    idLCServ: number;
    idTribNac: number;
    idTribMun: number;
    idNBS: number;
    indTipoControleEstoque: number;
    descGrupoItem: string;
    percToleranciaMenos: number;
    percToleranciaMais: number;
    nomeLocal: string;
    nomeDeposito: string;
    nomeDepositoPadrao: string;
    unidadeMedidaHora: boolean;
    nomeUnVendaItem: string; nomeUnArmazenagemItem: string;
    indPermiteAlterarQuantidade: boolean;
    indRealizaAgrupamentoProduto: boolean;
    indValidaTabelaPreco: boolean;
    ativo: boolean;

}
